import React from "react";
import styled from "styled-components/native";

import { useColorMode, themeTools, View } from "native-base"
import { extractSpacingProps } from "../utils";


export const Row = React.memo(({ level, ...props }) => {
    return <StyledRow colorMode={ useColorMode().colorMode } shadow={ level } { ...props } />
})


const StyledRow = styled(View).attrs((props) => {
    const {padding, ...spacingProps} = extractSpacingProps(props)[0] ?? {};
    return {
        shadow: props.shadow || undefined,
        borderRadius: props.borderRadius ?? 8,
        borderColor: props.borderColor ?? "muted.100",
        padding: padding ?? (props.shadow ? 4 : undefined),
        ...spacingProps,
        backgroundColor: props.backgroundColor ?? (!props.shadow ? undefined : themeTools.mode("light.50", "dark.50")(props)),
        width: props.width ?? "100%",
        flexDirection: 'row',
    }
})`
    ${
        (props) => props.shadow !== 1 
            ?   ""
            :   `
                border-width: 2px;
                border-style: solid;
                box-shadow: none;
            `
    }
`;